import { Button, Link, Text } from "north.js";
import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";

import "react-spring-bottom-sheet/dist/style.css";
import styled from "styled-components";

import { QR } from "src/static/img";

interface HardwareQRBottomSheetProps {
  isOpen: boolean;
  isCheckout: boolean; // true for checkout, false for return
  setShowCameraModal: (showCameraModal: boolean) => void;
  setShowScannerModal: (showScannerModal: boolean) => void;
}

const HardwareQRBottomSheet: React.FC<HardwareQRBottomSheetProps> = ({
  isOpen,
  isCheckout,
  setShowCameraModal,
  setShowScannerModal,
}) => {
  return (
    <StyledBottomSheet
      open={isOpen}
      onDismiss={() => setShowScannerModal(false)}
      // without this, the HasIdConfirmationModal is blocked
      blocking={false}
    >
      <ModalWrapper>
        <ModalHeader>
          <Text type="h1">Scan QR Code</Text>
          <ActionInfo>
            <Text type="h3">
              {isCheckout ? "Hardware Checkout" : "Hardware Return"}
            </Text>
            <Text>
              {isCheckout
                ? "Scan the QR code on the hardware request to mark as picked up"
                : "Scan the QR code on the hardware request to mark as returned"}
            </Text>
          </ActionInfo>
        </ModalHeader>

        <QR />
        <ModalButtons>
          <ScanningButton
            color="primary"
            size="md"
            onClick={() => {
              setShowScannerModal(false);
              setShowCameraModal(true);
            }}
          >
            Start scanning ➜
          </ScanningButton>
          <Link onClick={() => setShowScannerModal(false)}>
            Back to request list
          </Link>
        </ModalButtons>
      </ModalWrapper>
    </StyledBottomSheet>
  );
};

export default HardwareQRBottomSheet;

const StyledBottomSheet = styled(BottomSheet)`
  position: fixed;
  z-index: 10000 !important;
`;

const ModalWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0px;
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 42px;
  p {
    text-align: center;
  }
`;

const ActionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;

const ModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  margin-top: 45px;
`;

const ScanningButton = styled(Button)`
  --buttonWidth: 250px;
  width: var(--buttonWidth) !important;
  left: calc(50vw - var(--buttonWidth) / 2);
  height: 42px !important;
  * button {
    color: #43afde !important;
  }
`;
